/**
 * Check whether the multifactor step is settled for the current session.
 *
 * Mirrors the server's `canIssueCustomerToken`: the client may only render the
 * portal for a session the server would hand a customer token to. Keep the two
 * in sync — a client that is more permissive renders a portal without a socket,
 * one that is stricter parks a fully authorized user on the MFA screen.
 *
 * @param {Object} otp The `otp` slice of the store.
 *
 * @returns {boolean} True when the portal may be rendered.
 */
export default (otp) => {
  if (otp?.enabled === true) {
    return otp.verified === true;
  }

  // A customer requires a second factor, so skipping the setup does not settle
  // the step: it has to be configured first.
  if (otp?.required === true) {
    return false;
  }

  return otp?.skipped === true;
};
